import { callable } from './callable';

// Native push bootstrap — a NO-OP on the web (and SSR), so it's safe to call
// unconditionally from main.tsx. It only does anything inside the Capacitor native
// shell, which injects a global `window.Capacitor`. The `@capacitor/push-notifications`
// plugin is loaded via a dynamic, variable specifier so the web build never needs the
// package installed (install it per MOBILE-ANDROID.md before `cap sync`).
export async function initPush(): Promise<void> {
  const cap = typeof window !== 'undefined'
    ? (window as unknown as { Capacitor?: { isNativePlatform?: () => boolean; getPlatform?: () => string } }).Capacitor
    : undefined;
  if (!cap?.isNativePlatform?.()) return; // web / SSR → nothing to do

  try {
    const load = (mod: string): Promise<any> => import(/* @vite-ignore */ mod);
    const { PushNotifications } = await load('@capacitor/push-notifications');

    const perm = await PushNotifications.requestPermissions();
    if (perm.receive !== 'granted') return;
    await PushNotifications.register();

    const platform = cap.getPlatform?.() === 'ios' ? 'ios' : 'android';
    PushNotifications.addListener('registration', (t: { value: string }) => {
      callable('registerPushToken', { token: t.value, platform }).catch(() => {});
    });
    // Tapping a notification deep-links to the url we put in the push `data`.
    PushNotifications.addListener('pushNotificationActionPerformed', (a: { notification?: { data?: Record<string, string> } }) => {
      const url = a?.notification?.data?.url;
      if (url) window.location.assign(url);
    });
  } catch {
    /* native push plugin unavailable — ignore */
  }
}
